function pluralize(label, value) {
  return value === 1 ? label : `${label}s`
}

/**
 * Converts a millisecond duration to a short "X unit" label.
 * Uses the largest unit where value >= 1.
 *
 * @param {number} ms
 * @returns {string}
 */
export function formatDurationUnit(ms) {
  const absMs = Math.max(0, Number(ms) || 0)

  const second = 1000
  const minute = 60 * second
  const hour = 60 * minute
  const day = 24 * hour
  const week = 7 * day
  const month = 30 * day
  const year = 365 * day

  const units = /** @type {Array<[string, number]>} */ ([
    ["year", year],
    ["month", month],
    ["week", week],
    ["day", day],
    ["hour", hour],
    ["minute", minute],
    ["second", second],
  ])

  for (const [label, size] of units) {
    const value = Math.floor(absMs / size)
    if (value >= 1) {
      return `${value} ${pluralize(label, value)}`
    }
  }

  return "0 seconds"
}

/**
 * Format how long ago a date was, relative to a reference time.
 *
 * Examples:
 * - formatTimeAgo(twoHoursAgo, now) -> "2 hours ago"
 *
 * @param {Date} date
 * @param {Date} [now] Defaults to the current time
 */
export function formatTimeAgo(date, now = new Date()) {
  if (!(date instanceof Date) || !Number.isFinite(date.getTime())) {
    return ""
  }

  if (!(now instanceof Date) || !Number.isFinite(now.getTime())) {
    return ""
  }

  const diffMs = Math.max(0, now.getTime() - date.getTime())
  return `${formatDurationUnit(diffMs)} ago`
}
